import type { InterceptToggleInput } from '@terra/shared-dto-chat-types';

type InterceptSettings = {
  interceptEnabled: boolean;
  interceptResponsesEnabled: boolean;
};

export function getInterceptSettingsForAction(
  action: InterceptToggleInput['action'],
): InterceptSettings | null {
  switch (action) {
    case 'enable-requests':
      return {
        interceptEnabled: true,
        interceptResponsesEnabled: false,
      };
    case 'enable-responses':
      return {
        interceptEnabled: false,
        interceptResponsesEnabled: true,
      };
    case 'enable-all':
      return {
        interceptEnabled: true,
        interceptResponsesEnabled: true,
      };
    case 'disable':
      return {
        interceptEnabled: false,
        interceptResponsesEnabled: false,
      };
    default:
      return null;
  }
}
